import i18next from 'i18next';
import moment from 'moment';
import getTrainingSessionMaxEndDate from 'utils/getTrainingSessionMaxEndDate';

const isElearningDelivery = (values, trainingMethod) =>
  values?.deliveryMethod?.value === 'elearning' && trainingMethod === 'theory';

const toDateOnly = value => moment(value).format('YYYY-MM-DD');

const validateTrainingSessionForm = (values, { selectedPart } = {}) => {
  const errors = {};
  const trainingMethod = selectedPart?.trainingMethod || null;
  const elearning = isElearningDelivery(values, trainingMethod);

  if (!values.trainingModule?.value) {
    errors.trainingModule = i18next.t('trainingSession.trainingModuleRequired');
  }
  if (!values.trainingPart?.value) {
    errors.trainingPart = i18next.t('trainingSession.trainingPartRequired');
  }
  // Global uses value '' — require an option object, not option.value truthiness
  if (values.station == null) {
    errors.station = i18next.t('trainingSession.stationRequired');
  }
  if (!values.deliveryMethod?.value) {
    errors.deliveryMethod = i18next.t('trainingSession.deliveryMethodRequired');
  } else if (
    values.deliveryMethod.value === 'elearning' &&
    trainingMethod === 'theory' &&
    selectedPart &&
    selectedPart.hasMoodleLink === false
  ) {
    errors.deliveryMethod = i18next.t('trainingSession.moodleLinksRequired');
  }

  if (!values.startDate) {
    errors.startDate = i18next.t('trainingSession.startDateRequired');
  }

  if (!values.endDate) {
    errors.endDate = i18next.t('trainingSession.endDateRequired');
  }

  if (values.startDate && values.endDate && moment(values.endDate).isBefore(moment(values.startDate), 'day')) {
    errors.endDate = i18next.t('errors.endDateBeforeStartDate');
  }

  if (!elearning) {
    const maxStudentsRaw = values.maxStudents;
    const maxStudents = maxStudentsRaw === '' || maxStudentsRaw == null ? null : Number(maxStudentsRaw);
    if (maxStudents == null || Number.isNaN(maxStudents) || maxStudents < 1) {
      errors.maxStudents = i18next.t('trainingSession.maxStudentsRequired');
    }

    if (!values.startTime) {
      errors.startTime = i18next.t('trainingSession.startTimeRequired');
    }
    if (!values.endTime) {
      errors.endTime = i18next.t('trainingSession.endTimeRequired');
    }
    if (
      values.startDate &&
      values.endDate &&
      values.startTime &&
      values.endTime &&
      moment(values.startDate).isSame(moment(values.endDate), 'day') &&
      moment(values.endTime).isSameOrBefore(moment(values.startTime))
    ) {
      errors.endTime = i18next.t('errors.endTimeBeforeStartTime');
    }
  }

  if (selectedPart && values.startDate && values.endDate && !errors.startDate && !errors.endDate) {
    const partFrom = toDateOnly(selectedPart.availableFrom);
    const partTo = selectedPart.availableTo ? toDateOnly(selectedPart.availableTo) : null;
    const start = toDateOnly(values.startDate);
    const end = toDateOnly(values.endDate);

    if (start < partFrom) {
      errors.startDate = i18next.t('trainingSession.startBeforePartAvailable');
    } else if (partTo && start > partTo) {
      errors.startDate = i18next.t('trainingSession.startAfterPartAvailable');
    }

    if (end < partFrom) {
      errors.endDate = i18next.t('trainingSession.endBeforePartAvailable');
    } else if (partTo && end > partTo) {
      errors.endDate = i18next.t('trainingSession.endAfterPartAvailable');
    } else {
      const maxEndDate = getTrainingSessionMaxEndDate({
        startDate: values.startDate,
        availableTo: selectedPart.availableTo,
        validityMonthCount: selectedPart.validityMonthCount,
      });
      if (maxEndDate && end > toDateOnly(maxEndDate)) {
        errors.endDate = i18next.t('trainingSession.endAfterAllowedMax');
      }
    }
  }

  return errors;
};

export default validateTrainingSessionForm;
